import React from "react";
import logoImg from '../../assets/images/MizuWatch.png';
import logoImgs from '../../assets/images/MizuSmart_.png';
import {
    Link
  } from "react-router-dom";

class ResetPassword extends React.Component {
    render()
    {
    return(
        
        <section>
            <div className="vh-100 d-flex justify-content-between flex-column">
                <div className="banner-Image pt-lg-4">
                {(window.location.href.indexOf("mizuwatch.com") > -1)?
                    <img src={logoImg} className="pt-lg-5 img-fluid mx-auto d-table" alt="McCord Logo Image"/> :
                    <img src={logoImgs} className="pt-lg-5 img-fluid mx-auto d-table" alt="McCord Logo Image"/> }

                </div>
                <div className="login-form col-xl-6 position-relative">
                    <div className="bubble"></div>
                    
                    <div class="form-data">
                    <h3 className="text-blue text-center pb-0">Reset Password</h3>
                    <p className="fs-12 text-center text-grey pb-5">Enter your email and we’ll send you a link to get back into your account.</p>
                        <div class="forms-inputs"> 
                            <span>Email</span> 
                            <input class="form-control" id="username" name="username" placeholder="Enter your Email" type="text" value=""/>
                        </div>
                        <div class="mb-3">
                            <button type="submit" class="btn w-100 btn-submit">Reset Password</button> 
                        </div>
                        <Link to="/login" className="d-flex justify-content-center fs-16">Login</Link>
                    </div>
                    <div className="bubbleSmall"></div>
                </div>
                <div className="text-center l-footer">
                    <ul className="d-flex ps-0 gap-2 mb-2 mt-4 justify-content-center">
                        <span><a>Help Center</a></span> | <span><a>Privacy</a></span> | <span><a>Terms of Service</a></span>
                    </ul>
                    <span className="text-blue">Copyright © {new Date().getFullYear()}. All right reserved.</span>
                </div>
            </div>
        </section>

        )
    }
}

export default ResetPassword;